export default __webpack_public_path__ + "static/media/about.7e7cc2db.jpg";